<template>
    <footer class="text-white bg-cover bg-center">
        <div class="dark-overlay">
        <div class="overlay-content">
            <div class="container">

                <div class="row py-5">

                    <div class="col-lg-5 col-md-5 col-sm-12">

                       <h4>Contact Us</h4> <hr>

                       <img class="mb-4" src="@/assets/logo.png" alt="" width="120">

                        <p class="mb-1">
                            <a target="_blank" class="reset-anchor" href="https://mail.google.com/mail/u/0/?view=cm&fs=1&to=info@rgeahosa.org">
                              <img src="@/assets/svg/mail.svg" width="15px" height="15px">
                              <span class="text-small ">  info@rgeahosa.org </span>
                            </a>
                        </p>

                        <p class="mb-1">
                          <a class="reset-anchor" href="tel:+2330302811740">
                            <img src="@/assets/svg/phone.svg" width="15px" height="15px">
                            <span class="text-small ">  
                              +233 050 145 3030 
                            </span>
                          </a>
                        </p>

                        <p class="mb-1">
                            <a class="reset-anchor" href="#">
                              <img src="@/assets/svg/marker.svg" width="15px" height="15px">
                                <span class="text-small">  
                                   1 Club Road, Golden Gate, Regimanuel Gray Estate, East Airport, Accra
                                </span>
                            </a>
                        </p>
                       
                    </div>

                    <div class="col-lg-7 col-md-7 col-sm-12">
                        <div class="card rounded" style="background-color:#253031">
                            <div class="card-body">

                                <form @submit.prevent="contactUs()">

                                    <div class="row">
        
                                        <div class="form-group col-lg-12">
                                            <input class="form-control" type="text" v-model="message.name"
                                                   placeholder="Enter your fullname" required>
                                        </div>
                                        <div class="form-group col-lg-12">
                                            <input class="form-control" type="email" v-model="message.email"
                                                   placeholder="Email Address" required>
                                        </div>
                                        <div class="form-group col-lg-12">
                                            <textarea class="form-control" v-model="message.message" rows="5"
                                                      placeholder="Leave your message" required style="resize: none"></textarea>
                                        </div>
                                        <div class="form-group col-lg-12">
                                            <button class="btn btn-block btn-outline-primary" type="submit">
                                              Send Message
                                            </button>
                                        </div>
                                    </div>

                                </form>


                            </div>
                        </div>
                    </div>

                </div>
            </div>

           <div class="container text-center">

            <div class="border-top" style="padding:15px">
                 <a href="/">Home Rgea Hosa ©{{ new Date().getFullYear() }}</a>
            </div>

          </div>

        </div>
    </div>
  </footer>
</template>
<script>
import EmailServices from "../../services/EmailServices";
export default {
    data() {
        return {
           isAuthorized: false,
            message:{
                name:'',
                email:'',
                message:'',
            }
        }
    },

    methods: {
        async contact() {
            try{
              const response = await EmailServices.contactUs(this.message.name, this.message.email, this.message.message);
              return response;
            } catch (errors) {
              console.log(errors)
              return errors;
            }
        },

        contactUs() {
            if(this.message.name!=='' && this.message.email!='' && this.message.message!='') {
              this.contact().then((response) => {
                this.$toast.fire("Success :","Message send successfully","success");
                console.log(response);
                this.clear();
              }).catch((error) =>{
                  console.log(error);
              });
            }
        },

        clear(){
          this.message.name = '';
          this.message.email = '';
          this.message.message = '';
        }

    },

    mounted(){
        if(localStorage.getItem('token') != null){
            this.isAuthorized = true;
        }
    },

    computed:{
        selected(){
           return this.$route.name;
        },
    },
}
</script>